<template>
    <div class="c-footer">
        <FooterDetail />
        <div class="c-footer-box">
            <p class="c-footer-text">{{ $t("main:Copyright © 1998 - \{\{date\}\} Tencent. All Rights Reserved.腾讯公司 版权所有",{date:new Date().getFullYear()}) }}</p>
        </div>
    </div>
</template>

<script>
import FooterDetail from "@/components/FooterDetail.vue";
export default {
    name: "FooterBottom",
    components: { FooterDetail },
};
</script>
<style scoped lang="less">
.c-footer {
    background: #151829 url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/footer/bg-footer.png) no-repeat center top;
}
.c-footer-box {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 92px;
    padding-left: 24px;
    padding-right: 24px;
    border-top: 1px solid #32384a;
}
.c-footer-text {
    font-size: 12px;
    color: #b3b6be;
}
</style>
